// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { mergeTransactionData, setApiTimestamp, setTransactionData } from "_core/slices/datas/TransactionSlice";

const AdminCreateReportApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/create_report";

    // API実行
    const ExecAdminCreateReportApi = async (file, file_name) => {
        // 必要なリクエストを定義
        const requestParams = {
        };

        const requestBinaryParams = {
            file: {
                file: file,
                filename: file_name
            }
        };

        let response = null;
        let error = null;
        // console.log(url + "API開始");
        try {
            response = await ApiRequest({ url:url, requestParams:requestParams, requestBinaryParams:requestBinaryParams });
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0) {
            dispatch(setTransactionData({
                report: response['report'],
            }));
        }
        return { response, error };
    };

    return ExecAdminCreateReportApi;
};

export default AdminCreateReportApi;